import Accordion from '@/common/components/Accordion'
import { ErrorMessageWrapper } from '@/common/components/ErrorMessageWrapper'
import Skeleton from '@/common/components/Skeleton'
import { useEstablishmentContract } from '@/features/establishments/hooks/useEstablishmentContract'
import { BillDetailsSection } from './BillDetailsSection'
import { BillDetailsSectionLoadingState } from './BillDetailsSectionLoadingState'
import { FeeDetailsSection } from './FeeDetailsSection'
import { FeeDetailsSectionLoadingState } from './FeeDetailsSectionLoadingState'

interface ContractProps {
  title: string
  id: string
  showFeeDetails?: boolean
}

export const Contract = ({ title, id, showFeeDetails = true }: ContractProps) => {
  const {
    data: contract,
    error: contractError = {} as any,
    refetch: refetchContract,
    isPending: contractIsPending,
  } = useEstablishmentContract({ id })

  return (
    <Accordion
      defaultOpen
      head={
        <div className="flex items-center gap-x-2">
          <p className="font-bold text-lg">{title}</p>

          {contractIsPending ? (
            <Skeleton width={192} height={28} />
          ) : (
            <p className="font-light text-sm italic">{contract?.protocol_number}</p>
          )}
        </div>
      }
      body={
        <ErrorMessageWrapper
          className="max-h-96"
          statusCode={contractError?.status}
          notFoundHideButton
          refetchFunction={refetchContract}
        >
          <div className="flex flex-col gap-y-6">
            {contractIsPending ? <BillDetailsSectionLoadingState /> : <BillDetailsSection contract={contract} />}

            {showFeeDetails &&
              (contractIsPending ? <FeeDetailsSectionLoadingState /> : <FeeDetailsSection contract={contract} />)}
          </div>
        </ErrorMessageWrapper>
      }
    ></Accordion>
  )
}
